module.exports = __webpack_public_path__ + "static/img/top_message_name.bd95cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/top_message_name.png
// module id = UHaG
// module chunks = 0